import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    background-color: #eaf9f9;
    border-right: 1px solid ${colours.grey[400]};
    height: 100%;
    min-width: 53px;
    max-width: 53px;
    cursor: pointer;
  `;
});

export const Name = styled.div(props => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    padding-left: 7px;
    padding-right: 5px;
    height: 52px;
    width: 128px;
    margin: 38px -45px;
    font-size: 12px;
    color: ${palette.primary.dark};

    transform: rotate(-90deg);
    transform-origin: (0,0);
    overflow: hidden;
`;
});

export const Preview = styled.div(props => {
  const { colours, palette } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;

    cursor: pointer;
    width: 100%;
    height: 30px;
    padding-left: 10px;
    color: ${palette.primary.dark};
    border-bottom: 1px solid ${colours.grey[400]};

    &:hover {
      color: ${palette.secondary.dark};
    } 
  `;
});



// WEBPACK FOOTER //
// ./components/learning-journey/styled.js